import React, { createContext, useContext } from 'react';

import { type BackendAgentFieldDeleteOverlayResult } from './use-backend-agent-field-delete-overlay.ts';

const ProgressiveFieldDeleteRevealContext = createContext<
  BackendAgentFieldDeleteOverlayResult | undefined
>(undefined);

export function ProgressiveFieldDeleteRevealProvider({
  children,
  result
}: {
  children: React.ReactNode;
  result: BackendAgentFieldDeleteOverlayResult;
}) {
  return (
    <ProgressiveFieldDeleteRevealContext.Provider value={result}>
      {children}
    </ProgressiveFieldDeleteRevealContext.Provider>
  );
}

export function useProgressiveFieldDeleteRevealContext() {
  return useContext(ProgressiveFieldDeleteRevealContext);
}
